module.exports = __webpack_public_path__ + "img/startselfassessment.91adc672.png";